<script>
import { useConsult } from '@site/composables/useConsult'
import { CONTACT } from '@site/data/contact'
import AppIcon from '@site/components/common/AppIcon.vue'

export default {
  name: 'BottomCtaSection',
  components: { AppIcon },
  data() {
    const { open } = useConsult()
    return { open, CONTACT }
  },
}
</script>

<template>
  <section class="cta-section">
    <div class="cta-section__mesh">
      <span class="cta-section__mesh-blob cta-section__mesh-blob--1"></span>
      <span class="cta-section__mesh-blob cta-section__mesh-blob--2"></span>
    </div>
    <div class="container">
      <div class="cta-section__inner">
        <span class="cta-section__eyebrow">好生意，从一次咨询开始</span>
        <h2>开启你的好品味生意</h2>
        <p>现在咨询，即可获得门店管理方案与一对一演示</p>
        <div class="cta-section__actions">
          <button class="btn btn--primary" @click="open">立即咨询</button>
          <a :href="'tel:' + CONTACT.phone1.tel" class="btn btn--outline">
            <AppIcon name="phone" :size="16" /> {{ CONTACT.phone1.name }} {{ CONTACT.phone1.tel }}
          </a>
        </div>

        <div class="cta-section__contact">
          <div class="cta-item">
            <AppIcon name="user" :size="16" />
            <span>微信扫码（官方微信）</span>
          </div>
          <div class="cta-item">
            <AppIcon name="star" :size="16" />
            <span>抖音搜索「{{ CONTACT.douyin }}」</span>
          </div>
          <div class="cta-item">
            <AppIcon name="phone" :size="16" />
            <span>{{ CONTACT.serviceHours }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
.cta-section {
  position: relative;
  background: $gradient-brand;
  color: $color-white;
  padding: $space-section 0;
  overflow: hidden;

  &__mesh { position: absolute; inset: 0; pointer-events: none; }
  &__mesh-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(50px);
    &--1 { width: 480px; height: 480px; top: -100px; left: 50%; transform: translateX(-50%); background: rgba(255, 255, 255, 0.18); }
    &--2 { width: 340px; height: 340px; bottom: -80px; right: -60px; background: rgba(245, 158, 11, 0.28); }
  }

  &__inner { position: relative; text-align: center; max-width: 680px; margin: 0 auto; z-index: 1; }

  &__eyebrow {
    display: inline-block;
    font-size: 13px;
    font-weight: $weight-semibold;
    letter-spacing: 0.14em;
    color: rgba(255, 255, 255, 0.82);
    margin-bottom: 18px;
  }

  h2 {
    color: $color-white;
    font-size: $font-section;
    font-weight: $weight-black;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
  }

  p { font-size: 18px; color: rgba(255, 255, 255, 0.8); margin-bottom: 36px; }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 14px;
    margin-bottom: 44px;
  }

  &__contact {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 28px;
    padding-top: 28px;
    border-top: 1px solid rgba(255, 255, 255, 0.22);
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
  }

  .cta-item {
    display: flex;
    align-items: center;
    gap: 8px;

    svg { color: rgba(255, 255, 255, 0.85); }
  }

  @media (max-width: $bp-sm) {
    h2 { font-size: 32px; }
    p { font-size: 16px; }
    &__contact { flex-direction: column; align-items: center; gap: 14px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/BottomCtaSection.vue